import {
  PredictedPlace,
  GeocodeResult,
  GeocodeProps
} from '../types';

import { EMPTY_ARRAY } from 'shared/constants';

export const googleMapApi = {
  getPredictedPlaces: (search: string): Promise<PredictedPlace[]> =>
    new Promise((resolve) => {
      new google.maps.places.AutocompleteService().getPlacePredictions({ input: search, types: [] }, (data) => {
        const result = (data || EMPTY_ARRAY).map(({ description, place_id: placeId }) => ({
          key: description,
          value: description,
          metadata: { placeId }
        }));

        resolve(result);
      });
    }),
  geocode: async ({ placeId, coordinates }: GeocodeProps): Promise<GeocodeResult> => {
    const geocoder = new google.maps.Geocoder();
    const { results } = await geocoder.geocode({
      ...placeId && { placeId },
      ...coordinates && { location: new google.maps.LatLng(coordinates) }
    }, null);
    return {
      coordinates: {
        latitude: results[0].geometry.location.lat(),
        longitude: results[0].geometry.location.lng()
      },
      address: results[0].formatted_address || ''
    };
  }
};
